// extracted by mini-css-extract-plugin
export default {"Container":"Styles_Container__Q7Yka","rotate":"Styles_rotate__GQ9pe"};